import { createRouter, createWebHistory } from 'vue-router'
import SharePage from './components/SharePage.vue'
import NotFound from './components/NotFound.vue'

const routes = [
  {
    path: '/:token',
    name: 'share',
    component: SharePage
  },
  {
    path: '/',
    redirect: () => ({ name: 'not-found' })
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
